import {ErrorMessage, Field, Form, FormikProps} from 'formik'
import {withFormik} from 'formik'
import * as React from 'react'
import styled from 'styled-components'
import * as Yup from 'yup'
import {Alert} from '../../atoms/Alert'
import {Button} from '../../atoms/Button'
import {FieldError} from '../../atoms/FieldError'
import {Link} from '../../atoms/Link'
import {FieldInput} from '../../molecules/FieldInput'
import {media} from '../../utils/media'

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const translations = {
  'es': {
    emailPlaceholder: 'Correo electrónico',
    emailError: 'Esa dirección de correo electrónico no existe, intente nuevamente con un correo electrónico diferente',
    send: 'Enviar',
    backToLogin: 'Enviar Volver al inicio de sesión',
  },
  'en': {
    emailPlaceholder: 'Email',
    emailError: 'That email address doesn\'t exist, please try again with a different email',
    send: 'SEND',
    backToLogin: 'Back to Login',
  },
}

export interface IFormValues {
  email: string
}

export interface IViewProps {
  is: null | 'loading' | 'error' | 'success'
  doResetPassword: (values: IFormValues) => void
}

const ForgotPasswordViewInner = ({is, errors, touched}: FormikProps<IFormValues> & IViewProps) => (
  <Form>
    <Field name="email" placeholder={translations[lang].emailPlaceholder} style={{marginTop: 20}} component={FieldInput}/>
    <ErrorMessage name="email" component={FieldError}/>
    {is === 'error' && <Alert>{translations[lang].emailError}</Alert>}
    <div style={{marginTop: 20}}>
      <Button disabled={is === 'loading'} type="submit">
        {translations[lang].send}
      </Button>
    </div>
    <Link to="/login" style={{marginTop: 50}}>{translations[lang].backToLogin}</Link>
  </Form>
)

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Must be a valid email').required('Required'),
})


export const ForgotPasswordView = withFormik<IViewProps, IFormValues>({
  handleSubmit: async (values, {props, setErrors}) => {
    await props.doResetPassword(values)
  },
  validationSchema,
  mapPropsToValues: () => ({email: ''}),
})(ForgotPasswordViewInner)



// WEBPACK FOOTER //
// ./src/organisms/ForgotPasswordForm/ForgotPasswordView.tsx